import { BehaviorSubject } from 'rxjs';

export const activeRoute = new BehaviorSubject('');